import React,{useState,useEffect} from 'react'
import Card from "@material-ui/core/Card"
import {makeStyles} from "@material-ui/core/styles";
import income from "../../assets/img/incoming.png"
import outgoing from "../../assets/img/outgoing.png"
import normalizeMobilePhone from '../../fns/normalizeMobile';
// import formatNumber from '../../fns/formatNumber';
import moment from 'moment-jalaali'
import { useHistory } from 'react-router-dom';
import AnonymousCall from './AnonymousCall';
import {__} from "../../utils/i18n"
import Collapse from '@material-ui/core/Collapse';

const useStyles = makeStyles(theme=>({
    card:{
      padding:15,
      width:'350px',
      display:'grid',
      gridTemplateColumns:'1fr',
    },
    incomingCard:{
        border:'1px solid #33691e',
        background:`url(${income})`,
        backgroundSize:'32px 32px',
        backgroundPosition:'10px 10px',
        backgroundRepeat:'no-repeat',
        backgroundColor:'#f1f8e9'
    },
    outgoingCard:{
        border:'1px solid #01579b',
        background:`url(${outgoing})`,
        backgroundSize:'32px 32px',
        backgroundPosition:'10px 10px',
        backgroundRepeat:'no-repeat',
        backgroundColor:'#e1f5fe'
    },
    title:{
      fontSize:14,
      fontWeight:900
    },
    green:{
        color:"#33691e"
    },
    blue:{
        color:'#01579b'
    },
    top:{
        display:'flex',
        position:'relative',
        alignItems:'center'
    },
    closeBtn:{
        position: 'absolute',
        top:0,
        left:0
    },
    phoneNumber:{
        width:'100%',
        fontSize:22,
        color:'#000',
        textAlign:'center',
        margin:theme.spacing(0),
        '& > span':{
            fontSize:10
        }
    },
    userFullName:{
        color:'#000',
        textAlign:'center',
        fontSize:22,
        fontWeight:900
    },
    extras:{
        color:'gray',
    }
}))

    

const CallCard = ({voipData,onClose,show}) => {
    const classes = useStyles();
    const [open,setOpen] = useState(show);
    const history = useHistory();
    const {user,phoneNumber,extraInfos} = voipData;
    let stringExtraInfos = extraInfos?.filter(x=>typeof(x)==='string');
    const objectExtraInfos = extraInfos?.filter(x=>typeof(x)!=='string');
    for(const obj of objectExtraInfos){
        if(obj?.session){
            stringExtraInfos.push(`آخرین ورود: ${moment(obj.session.updatedAt).format('jYYYY/jMM/jDD')}`)
        }
        // if(obj?.credit){
        //     stringExtraInfos.push(`موجودی کیف پول: ${formatNumber(obj.credit)} تومان`)
        // }
        if(obj?.lockStatus?.lock && obj?.lockStatus?.order){
            stringExtraInfos.push(`وضعیت: ${__(obj.lockStatus.order.status)}`);
            stringExtraInfos.push(`${obj.lockStatus.order.cargos[0].type.title}: ${obj.lockStatus.order.destination.title}`);
            obj.lockStatus.order?.operator && stringExtraInfos.push(`کارشناس حمل: ${obj.lockStatus.order.operator.firstName} ${obj.lockStatus.order.operator.lastName}`);
        }
        if(obj?.interests){
            const states = obj?.interests?.[0]?.states?.map(s=>s.title)?.join('،');
            obj?.interests?.[0] && stringExtraInfos.push(`مسیرهای رزرو شده: ${states} - تاریخ رزرو: ${moment(obj?.interests?.[0]?.updatedAt).format('jMM/jDD')}`); 
        }
        
    }

    const handleClickUser = ()=>{
        if(user?.role?.[0]==='customer') history.push(`/protected/admin/users/customer/${user?._id}`)
        else if(user?.role?.[0]==='driver') history.push(`/protected/admin/users/driver/${user?._id}`)
        
    }
    const handleShow = ()=>{
        setOpen(true);
    }
    const handleHide = ()=>{
        setOpen(false);
    }

    useEffect(()=>{
        if(open===show) return;
        setOpen(show)
    },[show])

    return (
        <Card onMouseOver={handleShow} onMouseOut={handleHide} className={`${classes.card} ${voipData.callType==='in'?`${classes.incomingCard}`:`${classes.outgoingCard}`}`}>
            <div className={classes.top}>
                <div className={classes.closeBtn} style={{cursor:'pointer'}} onClick={()=>{onClose(voipData.callUID)}}>X</div>
                <div className={classes.phoneNumber} style={{cursor:'pointer'}} onClick={handleClickUser}> {normalizeMobilePhone(phoneNumber)} {!open && <span>{user?`${user?.company?user.company:`${user?.firstName || ''} ${user?.lastName || ''}`}`:`شماره ناشناس`}</span>}</div>
            </div>
            {/* <div className={`${classes.title} ${voipData.callType==='in'?`${classes.green}`:`${classes.blue}`}`}>{voipData.callType==='in'?`تماس ورودی`:`در حال تماس`}</div> */}
            <Collapse in={open}>
            <div className={classes.userFullName} style={{cursor:'pointer'}} onClick={handleClickUser}>{user?`${user?.company?user.company:`${user?.firstName || ''} ${user?.lastName || ''}`}`:<AnonymousCall mobilePhone={phoneNumber} />}</div>
            <div className={classes.extras}>
                <ul>
                    {stringExtraInfos?.map((x,i)=><li key={i}>{x}</li>)}
                </ul>
            </div>
            </Collapse>
        </Card>
    )}

export default React.memo(CallCard)